export class Cls_StudentData {
  StudentID?: number;
  CenterID?: number;
  CompanyID?: number;
  BeltID?: number;
  FirstName?: string;
  MiddleName?: string;
  LastName?: string;
  DOB?: string;
  Email?: string;
  MobileNo?: string;
  Address?: string;
  City?: string;
  State?: string;
  Pincode?: string;
  EmergencyContact?: string;
  ParentFirstName?: string;
  ParentLastName?: string;
  ParentContactNO?: string;
  ParentEmail?: string;
  Relation?: string;
  MedicalCondition?: string;
  Aadhaar?: File;
  EducationCert?: File;
  MedicalCert?: File;
  Weight?: string;
  Height?: string;
  Flexibility?: string;
  Gender?: string;
  RegistrationDate?: Date;
  IsActive?: boolean;
  UserTypeID?: number;
  ClassID?: number;
  PackageID?: number;
  FatherName?: string;
  MotherName?: string;
  StudentPackage?: Cls_PackageData[];
  StudentClasses?: Cls_ClassData[];
  packageSubscriptions?: Cls_PackageData[];
  classEnrollments?: Cls_ClassData[];
  Documents?: DocumentObject[];
  ProfileDocuments?: DocumentObject[];
  BMI?: string;
}

export interface DocumentObject {
  Category: string;
  FileName: string;
  MimeType: string;
  Base64: string | null; // ✅ THIS IS THE FIX
  DID?: number;
}

export class Cls_CoachData {
  TrainerID?: number;
  CompanyID?: number = 0;
  CenterID?: number = 0;
  RegionID?: number;
  AreaID?: number;
  UserType?: string;
  TrainerName?: string;
  TrainerLastName?: string;
  DOB?: string;
  Gender?: string;
  MobileNumber?: string;
  EmergencyNumber?: string;
  Email?: string;
  Address?: string;
  City?: string;
  State?: string;
  Pincode?: string;
  Specialization?: string;
  ExperienceYears?: number;
  UserTypeID?: number;
  UserAccessList?: Cls_UserAccessList[];
  UserAccess?: Cls_UserAccessList[];
  Documents?: DocumentObject[];

  IsActive?: boolean;

  Aadhaar?: File;
  EducationCert?: File;
  MedicalCert?: File;
}

export class Cls_UserAccessList {
  UMID?: number;
  RegionID?: number;
  CityID?: number;
  AreaID?: number;
  CenterID?: number;
  IsActive?: boolean;
}

export class Cls_CenterData {
  CenterID?: number;
  AreaID?: number;
  RegionID?: number;
  CityID?: number;
  CompanyID?: number;
  CenterName?: string;
  CenterCode?: string;
  MaxCapacity?: number;
  Address?: string;
  District?: string;
  State?: string;
  Country?: string;
  Pincode?: string;
  ContactNumber?: string;
  AlternateNumber?: string;
  Email?: string;
  CreatedBy?: string | null;
  UpdatedBy?: string | null;
  IsActive?: boolean;
  CreatedDate?: string;
  UpdatedDate?: string;
}

export class Cls_PackageData {
  PackageID?: number;
  PackageName?: string;
  CenterID?: any;
  PackageAction?: string;
  ID?: any;
  RegionIDs?: number[];
  AreaIDs?: number[];
  AreaID?: number;
  MembershipID?: number = 1;
  TrainerPercentage?: number;
  Amount?: number;
  CGST?: number;
  SGST?: number;
  FinalAmount?: number;
  RenewAmount?: number;
  MinimumAmount?: number;
  IsPT?: boolean;
  TrainerID?: number;
  ClassID?: number; // Added ClassID to link package with a specific class
  StartTime?: string;
  EndTime?: string;
  Status?: string | null;
  Description?: string;
  IsRenewable?: boolean;
  IsUpgradable?: boolean;
  IsTransferable?: boolean;
  CreatedBy?: number;
  UpdatedBy?: number | null;
  IsActive?: boolean;
  CreatedDate?: string;
  UpdatedDate?: string;
  DurationText?: string;
  DurationInMonths?: number;
  Duration?: number;
  DurationInDays?: number;
  IsDaysPeriod?: any;
  AreaDetails?: { AreaID: number; AreaName: string };

  TotalDays?: number;
  PackageAccessList?: any[];
}

export class Cls_MenuList {
  MenuID?: number;
  MenuName?: string;
  ParentMenuID?: number;
  MenuCaption?: string;
  RouterPath?: string;
  iorder?: number;
  svg_default?: string;
  IconName?: string;
}

export class Cls_ClassData {
  ClassID?: number;
  MembershipID?: number;
  PackageID?: any;
  CenterID?: number;
  ClassName?: string;
  ClassCode?: string;
  ClassStartDate?: string; // Use Date if you're parsing it
  ClassEndDate?: string;
  StartTime?: string;
  EndTime?: string;
  TotalDaysOfWeek?: number;
  TrainerID?: number;
  MaxStudents?: number;
  Description?: string;
  DaysOfWeek?: string[];
  frequency?: string;
  StudentID?: number[];
  IsActive?: boolean;
  MembershipName?: string;
  PackageName?: string | null;
  TrainerName?: string;
  Students?: Student[];
  Trainer?: Trainer[];
  Trainers?: Trainer[];
  Days?: DaySchedule[];
  Latitude?: string;
  Longitude?: string;
}

export interface DaySchedule {
  StartTime: string;
  EndTime: string;
  [key: string]: any;
}

export interface ITrainer {
  TrainerID: number;
  TrainerName: string;
  MobileNumber: string;
  Email: string;
}

export interface IDaySchedule {
  Day: string;
  StartTime: string;
  EndTime: string;
}

export class ClassData {
  ClassID?: number;
  MembershipID?: number;
  PackageID?: any;
  CenterID?: number;
  Days: { DayName: string; StartTime: string; EndTime: string }[] = [];
  ClassName?: string;
  ClassCode?: string;
  TrainerID: number[] = [];
  Trainers: ITrainer[] = [];
  ClassStartDate?: string;
  ClassEndDate?: string;
  StartTime?: string;
  EndTime?: string;
  TotalDaysOfWeek?: number;
  DaysOfWeek?: string[];
  frequency?: string;
  StudentID?: number[];
  StudentIDs?: number[];
  Description?: string;
  MaxStudents?: number;
  IsActive?: boolean;
  Latitude?: string;
  Longitude?: string;
}

export class Student {
  StudentID?: number;
  FirstName?: string;
  MiddleName?: string;
  LastName?: string;
  MobileNo?: string;
}

export class Trainer {
  TrainerID?: number;
  TrainerName?: string;
  TrainerLastName?: string;
  MobileNumber?: string;
  Email?: string;
}
export class Cls_StudentAttendance {
  [x: string]: any;
  StudentID?: number;
  CenterID?: number;
  TrainerID?: number;
  ClassID?: number;
  AttendanceDate?: string;
  SessionStart?: string;
  SessionEnd?: string;
  ModeOfEntry?: string;
  AttendanceStatus?: string;
}

export class Cls_RegionData {
  RegionID?: number;
  RegionName?: string;
  IsActive?: boolean;
}
export class Cls_CityData {
  RegionID?: number;
  CityID?: number;
  CityName?: string;
  IsActive?: boolean;
}

export class Cls_AreaData {
  RegionID?: number;
  CityID?: number;
  AreaID?: number;
  AreaName?: string;
  IsActive?: boolean;
}

export class Cls_PaymentTransaction {
  PTID?: number = 0;
  TransactionNo?: string = "";
  PayeeName?: string = "";
  PayeeMobileNo?: string = "";
  Amount?: number = 0;
  PaidAmount?: number = 0;
  Remarks?: string = "";
  StudentID?: number = 0;
  MembershipID?: number = 0;
  ClassID?: number = 0;
  PackageID?: number = 0;
  TrainerID?: number = 0;
  IsDiscountable?: any = {};
  Discount?: number = 0;
  DiscountReason?: string = "";
  RemainingSessions?: number = 0;
  IsFreeze?: boolean = true;
  StartDate?: string = "";
  EndDate?: string = "";
  IsActive?: boolean = true;
  PaymentMethod?: string = "";
}

export class Cls_CompanyData {
  CompanyID?: number;
  CompanyName?: string;
  CompanyType?: string;
  ContactNumber?: string;
  City?: string;
  State?: string;
  Country?: string;
  Address?: string;
  PrimaryEmail?: string;
  Website?: string;
  CGST?: string;
  SGST?: string;
  PAN?: string;
  CompanyLogo?: string;
  GSTIN?: string;
}

export class Cls_StudentEnquiry {
  FirstName?: string;
  MiddleName?: string;
  LastName?: string;
  DateOfBirth?: string;
  Gender?: string;
  MobileNo?: string;
  Email?: string;
  CenterName?: string;
  Pincode?: string;
  City?: string;
  State?: string;
  Height?: number;
  Weight?: number;
  Age?: number;
  AlternateMobileNo?: string;
  ExperienceLevel?: string;
  PreferredBatchTime?: string;
  PreferredDays?: string;
  MedicalCondition?: string;
  EnquirySource?: string;
  ReferenceName?: string;
  CounsellorName?: string;
  CreatedBy?: number;
}

export class Cls_StudentEvaluation {
  StudentID?: number;
  CentreID?: number;
  EvaluationYear?: Date;
  QuarterNumber?: number;
  Attendance?: number;
  Height?: number;
  Weight?: number;
  BMI?: number;
  FatPercentage?: number;
  Cleanliness?: number;
  Discipline?: number;
  Grasping?: number;
  Conditioning?: number;
  Basics?: number;
  Punches?: number;
  Kicks?: number;
  Combination?: number;
  Throws?: number;
  Falls?: number;
  Rolls?: number;
  Kata?: number;
  Kumite?: number;
  ScopeofImprovement?: number;
  Strength?: number;
  Remarks?: string;
}

// export class Cls_Event {
//   EventName?: string;
//   EventDescription?: string;
//   EventType?: string;

//   CenterID?: number[];
//   ClassID?: number[];
//   StudentID?: number[];

//   StartDate?: Date;
//   EndDate?: Date;

//   Venue?: string;
//   City?: string;

//   MaxParticipants?: number;
//   RegistrationFee?: number;
//   RegistrationLastDate?: Date;

//   IsActive?: boolean;
// }

export class Cls_EventData {
  EventName!: string;
  EventDescription!: string;
  EventType!: string;
  StartDate!: string;
  EndDate!: string;
  Venue!: string;
  City!: string;
  MaxParticipants!: number;
  RegistrationFee!: number;
  RegistrationLastDate!: string;
  Description!: string;
  IsActive!: boolean;
}

export class Cls_BeltData {
  BeltID?: number;
  BeltName?: string;
  BeltColor?: string;
  LevelType?: string;
  BeltFees?: number;
  IsActive?: boolean;
}

export class Cls_ProductCompanyData {
  CompanyID?: number;
  CompanyName?: string;
  Date?: Date;
  GSTNo?: number;
  Mobile?: string;
  Address?: string;
  ContactPersonName?: string;
  ContactPersonNumber?: string;
}

export class Cls_ProductData {
  ProductID?: number;
  CompanyID: number = 0;
  ProductName: string = "";
  Description: string = "";
  SGST: number = 0;
  CGST: number = 0;
  Amount: number = 0;
  StudentDiscount: number = 0;
  MinDiscount: number = 0;
  Remarks: string = "";
  IsActive: boolean = true;
  Image: string = "";
  Documents: DocumentObject[] = [];
  Size: { SizeID: number; Quantity: number }[] = [];
}

export class Cls_TrainerAttendance {
  TrainerClassAttendanceID?: number;
  AttendanceDate?: string;
  ClassID?: number;
  ClassDayID?: number;
  CenterID?: number;
  AssignedTrainerID?: number;
  AttendedTrainerID?: number;
  AttendanceTime?: string;
  AttendanceStatus?: string;
  IsProxy?: boolean;
  DistanceInMeters?: number;
  Remarks?: string;
  CreatedBy?: number;
  CreatedDate?: string;
  IsActive?: boolean;
  Class?: {
    ClassID: number;
    ClassName: string;
    ClassCode: string;
    StartTime: string | null;
    EndTime: string | null;
  };
  Center?: {
    CenterID: number;
    CenterName: string;
  };
  AttendedTrainer?: {
    TrainerID: number;
    TrainerName: string;
    TrainerLastName: string;
  };
  AssignedTrainer?: {
    TrainerID: number;
    TrainerName: string;
    TrainerLastName: string;
  };
  ClassDay?: {
    ClassDayID: number;
    DayName: string;
  };
}

export class Cls_AddMoneyCredit {
  StudentID: number = 0;
  PayeeName: string = "";
  PayeeMobileNo: string = "";
  PaymentMode: number = 0;
  Amount: number = 0;
  TransactionNo: string = "";
  Remarks: string = "";
}
